<section class="w-full h-full bg-white md:px-10 md:py-16 px-4 py-8 overflow-x-hidden">
  <div class="container mx-auto h-full w-full">
    <div class="flex md:flex-row flex-col justify-start gap-8 md:gap-14 items-center h-full w-full">
      <div
        appScrollAnimate="animate-move-in-right"
        class="max-md:w-full w-1/2 h-full rounded-2xl overflow-hidden"
      >
        <img src="lite/lite_good.png" alt="Flexible Image" class="w-full h-full object-cover" />
      </div>

      <div
        appScrollAnimate="animate-move-in-left"
        class="flex flex-col items-start justify-start gap-4"
      >
        <h2
          i18n="lite.good|How's Good? heading@@lite.good.title"
          class="md:text-3xl text-2xl font-bold text-black"
        >
          How's Good?
        </h2>
        <ul class="flex flex-col items-stretch md:items-start justify-start gap-2">
          <li>
            <p
              class="bg-main-green text-white text-sm md:text-base font-medium px-4 py-2 rounded-full"
            >
              <img src="check_white.svg" alt="Check" class="inline-block mr-2" />
              <span i18n="lite.good|Joining Easily feature@@lite.good.joiningEasily"
                >Joining Easily</span
              >
            </p>
          </li>
          <li>
            <p
              class="bg-main-green text-white text-sm md:text-base font-medium px-4 py-2 rounded-full"
            >
              <img src="check_white.svg" alt="Check" class="inline-block mr-2" />
              <span i18n="lite.good|Managing Easily feature@@lite.good.managingEasily"
                >Managing Easily</span
              >
            </p>
          </li>
          <li>
            <p
              class="bg-[#9B9B9B] text-white text-sm md:text-base font-medium px-4 py-2 rounded-full"
            >
              <img src="close_white.svg" alt="Close" class="inline-block mr-2 w-6 h-6" />
              <span i18n="lite.good|No Fees feature@@lite.good.noFees">No Fees</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
